import React from 'react';
import Hero from '../components/sections/Hero.jsx';
import Services from '../components/sections/Services.jsx';
import Skills from '../components/sections/Skills.jsx';
import Projects from '../components/sections/Projects.jsx';
import Portfolio from '../components/sections/Portfolio.jsx';
import Testimonials from '../components/sections/Testimonials.jsx';
import Contact from '../components/sections/Contact.jsx';
import Layout from '../components/layout/Layout.jsx';

const Home = () => {
  return (
    <Layout>
      <Hero />
      <Services />
      <Skills />
      <Projects />
      <Portfolio />
      <Testimonials />
      <Contact />
    </Layout>
  );
};

export default Home; 